import { render } from "./spotAccount.vue?vue&type=template&id=2cdca972&scoped=true"
import script from "./spotAccount.vue?vue&type=script&lang=js"
export * from "./spotAccount.vue?vue&type=script&lang=js"

import "./spotAccount.vue?vue&type=style&index=0&id=2cdca972&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cdca972"]])

export default __exports__